var cache = {
    entry: {
        url: null,
        params: null,
        query: null
    },
    mounted() {
        let entry = null, stream = localStorage.getItem("entry");

        try {
            entry = JSON.parse(stream);
        } catch (e) {
            entry = null;
        }

        if (entry) {
            cache.entry = entry;
        }
        
    },
    clear: () => {
        cache.entry = {
            url: null,
            params: null,
            query: null
        };
        localStorage.setItem("entry", JSON.stringify(cache.entry));
    },
    get: () => {
        if (cache.entry.url || cache.entry.query || cache.entry.params) {
            let entry = cache.entry;
            return entry;
        }
        return null;
    },
    set: (entry) => {
        cache.entry = Object.assign(cache.entry, entry);
        localStorage.setItem("entry", JSON.stringify(cache.entry));
    }
};

export default cache;
